export default "__VITE_ASSET__Pwa0JdrM__"